import React from 'react';
import View from 'shared/components/ui/view';
import Text from 'shared/components/ui/text';
import Experiment from 'shared/components/experiment';
import Variant from 'shared/components/experiment/variant';

export default function GuestExperiment({ checked, onChange }) {
  return (
    <Experiment name="Guest Checkout" defaultVariant="Null">
      <Variant name="Null">{''}</Variant>
      <Variant name="Show Checkbox">
        <div className="row">
          <View margin="sm" className="col-xs-12 col-md-6">
            <label htmlFor="guestCheckout" className="clickable">
              <input
                type="checkbox"
                id="guestCheckout"
                name="guestCheckout"
                checked={checked}
                onChange={onChange}
              />
              <View inlineBlock padding={{ sides: 'xs' }}>
                <Text tag="span" secondary>
                  Checkout as guest
                </Text>
              </View>
            </label>
          </View>
        </div>
      </Variant>
    </Experiment>
  );
}
